import httpClient from './httpClient';

const reporteService = {
  obtenerTrabajadoresActivosPension: async (empresaId, fecha = null) => {
    const params = new URLSearchParams({ empresa_id: empresaId });
    if (fecha) params.append('fecha', fecha);
    const response = await httpClient.get(`/reportes/trabajadores-activos-pension?${params.toString()}`);
    return response.data;
  },

  obtenerConceptosIngresoBoleta: async (empresaId, fecha = null) => {
    const params = new URLSearchParams({ empresa_id: empresaId });
    if (fecha) params.append('fecha', fecha);
    const response = await httpClient.get(`/reportes/conceptos-ingreso-boleta?${params.toString()}`);
    return response.data;
  },
};

export default reporteService;
